// extracted by mini-css-extract-plugin
module.exports = {"otherDatesSection":"otherDatesSection_35kU0","hs":"hs_1G-gU","scroll":"scroll_2XPtH"};